import { omit } from 'lodash-es';

import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';
import { useToastStore } from '@modules/toast/store';

import type {
  ISettingsInformationItemSavePayload,
} from '../types';
import {
  SETTINGS_INFORMATION_SAVE_QUERY_KEY,
  SETTINGS_INFORMATION_SAVE_URL,

} from '../constants';

export default function useSettingsInformationSaveMutation(): ReturnType<
  typeof useContextMutation<void, Error, ISettingsInformationItemSavePayload>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();
  const { getStaticPagePermission } = useStaticPageConfig();

  return useContextMutation<
    void,
    Error,
    ISettingsInformationItemSavePayload
  >({
    mutationKey: [SETTINGS_INFORMATION_SAVE_QUERY_KEY],
    mutationFn: (payload: ISettingsInformationItemSavePayload) => fetchPost(
      SETTINGS_INFORMATION_SAVE_URL,
      omit(payload, 'page'),
      {
        urlParams: {
          page: payload.page,
        },
        permission: getStaticPagePermission(payload.page),
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_INFORMATION_SAVE_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
